import React, { useEffect, useState } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";

const libraries = ["places"];
const mapContainerStyle = {
  width: "100%",
  height: "100vh",
};

const center = {
  lat: 7.2905715, // default latitude
  lng: 80.6337262, // default longitude
};

const GoogleMapComponent = ({ searchText, setIsLoading }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyDgm3VBE9YF9fIYqHU6Cue4OfJBtJBlxj4",
    libraries,
  });
  const [mapCenter, setMapCenter] = useState(center);
  const [markerPosition, setMarkerPosition] = useState(center);

  
  useEffect(() => {
    if (!isLoaded) {
      console.log(isLoaded, "isLooooooooooooo");
      setIsLoading(false); // Map load hone ke baad loading state update karega
    }
  }, [isLoaded]);

  if (loadError) {
    return <div>Error loading maps</div>;
  }

  if (!isLoaded) {
    setIsLoading(true);
    return <div>Loading maps</div>;
  }

  const handleSearchByName = () => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: searchText }, (results, status) => {
      if (status === "OK") {
        const location = results[0].geometry.location;
        console.log(location, "aSAJHSAsjasjjh");
        setMapCenter({ lat: location.lat(), lng: location.lng() });
        setMarkerPosition({ lat: location.lat(), lng: location.lng() });
      } else {
        alert("Geocode was not successful for the following reason: " + status);
      }
    });
  };

  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      zoom={15}
      center={mapCenter}
    >
      <Marker
        position={markerPosition}
        icon={{
          url: "http://maps.google.com/mapfiles/ms/icons/orange-dot.png",
        }}
      />
    </GoogleMap>
  );
};

export default GoogleMapComponent;
